import React, { createContext, useState, useContext, useCallback } from 'react';

const AuthContext = createContext(null);

const useLocalStorage = (key, initialValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch {
      return initialValue;
    }
  });

  const setValue = useCallback((value) => {
    try {
      setStoredValue(value);
      if (value === null) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify(value));
      }
    } catch (e) {
      console.error('Local storage error:', e);
    }
  }, [key]);

  return [storedValue, setValue];
};

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useLocalStorage('ai_auth', null);

  const login = useCallback((data) => {
    setAuth(data);
  }, [setAuth]);

  const logout = useCallback(() => {
    setAuth(null);
  }, [setAuth]);

  const value = { auth, login, logout };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};